import { IExtendedUser, IMyOpenTasks, IMyOpenTasksPayload } from "src/common/types";
import { getItem } from "src/helpers";
import { getCall } from "src/services";

export const getUser = (userId: string): Promise<IExtendedUser> =>
  new Promise((resolve, reject) => {
    return getItem(`employee:${userId}`).then(([savedUser, saveItem]) => {
      if (savedUser) {
        return resolve(savedUser);
      } else {
        return (getCall({ url: `/v1/feedback/participant/${userId}` }) as Promise<IExtendedUser>)
          .then(user => {
            saveItem(user);
            resolve(user);
          })
          .catch(err => reject(err));
      }
    });
  });

export const getMyOpenTaks = (): Promise<IMyOpenTasks> =>
  new Promise((resolve, reject) => {
    return (getCall({ url: "/v1/feedback/talk/openTasks" }) as Promise<IMyOpenTasksPayload>)
      .then(
        ({
          directSupervisorOpenTaskCount: myEmployeesCount,
          selfAssessmentOpenTaskCount: myFeedbacksCount,
          peerAssessmentOpenTaskCount: peersCount,
          anonymousDirectSupervisorOpenTaskCount: anonymousCount
        }) =>
          resolve({
            myEmployeesCount,
            myFeedbacksCount,
            peersCount,
            anonymousCount
          })
      )
      .catch(error => reject(error));
  });
